import {axiosGetHandler, axiosPostHandler} from './config'
import {extractAPIValues} from '_lib/utils/utils'
const {BASE_API} = extractAPIValues()

export function getTaskList (args) {
  let url = BASE_API + '/chatroom/task/get_user_tasks'
	return axiosGetHandler(url, args)
}

export function completeOnceTask (args, form) {
  let url = BASE_API + '/chatroom/task/finish_task'
  return axiosPostHandler(url, args, form)
}

export function updateLevelChangeNotify (args, form) {
  let url = BASE_API + '/chatroom/v2/task/notified'
  return axiosPostHandler(url, args, form)
}


export function getOnceTasks (args) {
  let url = BASE_API + '/chatroom/v2/task/once_tasks'
	return axiosGetHandler(url, args)
}

export function completeOnceTaskV2 (args, form) {
  let url = BASE_API + '/chatroom/v2/task/finish'
  return axiosPostHandler(url, args, form)
}
